/*eslint-disable*/
import React from "react";
// react components for routing our app without refresh
// import { Link } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";
// import IconButton from '@material-ui/core/IconButton';
// @material-ui/icons
import { Apps, CloudDownload, AccountCircle, Face } from "@material-ui/icons";

// core components
import CustomDropdown from "components/CustomDropdown/CustomDropdown.jsx";
import Button from "components/CustomButtons/Button.jsx";

import headerLinksStyle from "assets/jss/material-kit-react/components/headerLinksStyle.jsx";


class HeaderLinks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false

    };
  }

  render() {
    const {
      classes,
      dataType,
      changeLoginType,
      naniEditData,
      naniLogout,
      brands
    } = this.props;

    function cblogin() {
      //nanicool.link 引入的方法
      getLoginNaniCool(function myfunction(result) {
        if (getNani_UserID() != "") {
          //callUserTokenDate(getNani_UserProfile());
          changeLoginType(true, getNani_UserID(), result);
        }
      })
    }

    function cbEditLogin() {
      //nanicool.link 引入的方法
      updatePersonalData(function myfunction(result2) {
        //沒什麼特別必要做的事情，資料存放在會員中心
        //資料也回傳回來修改localstroage
        //可取用2的 取得個人ID  取得個人名稱 取得Email 取得個人資料
        naniEditData(result2);
      })

    }
    function cbLogout() {
      //nanicool.link 引入的方法
      NanilCoollogout();
      //呼叫App修改資料
      naniLogout();
    }
    function handleClick(event) {
      // console.log(this);
      selectTab(event.currentTarget.getAttribute("tab"));
      var move = event.currentTarget.getAttribute("move");
      if (move && move != "TOP") {
        $('html,body').animate({ scrollTop: $('#' + move).offset().top }, 800);
      }
      else if (move == "TOP") {
        $('html,body').animate({ scrollTop: 0 }, 800);
      }
    }


    // var menuItem = brands.map((page, pageIndex) =>


    //   (<ListItem className={classes.listItem}><Button className={classes.title} key={page.ID} tab={page.TAB} move={page.DIV} onClick={handleClick} disabled={page.TAB !== "Home" && !dataType.isLogin} style={{ display: (dataType.isMobile) ? {} : 'none' }}  >{page.Name}</Button> </ListItem>));



    return (
      <List className={classes.list}>
        <ListItem className={classes.listItem} style={{ display: (!dataType.isLogin) ? 'block' : 'none' }} >
          <Button
            id="nouser"
            buttonText="請登入"
            color="transparent"
            target="_blank"
            className={classes.navLink}
            onClick={cblogin}
          >
            <AccountCircle className={classes.icons} />
          </Button>
        </ListItem>
        <ListItem className={classes.listItem} style={{ display: (dataType.isLogin) ? 'block' : 'none' }}>
          <CustomDropdown
            noLiPadding
            buttonText={(dataType.userID ? dataType.userID : "")}
            buttonProps={{
              className: classes.navLink,
              color: "transparent"
            }}
            buttonIcon={Face}
            dropdownList={[
              // <Link to="/" className={classes.dropdownLink}>
              //   All components
              // </Link>,
              <a
                target="_blank"
                className={classes.dropdownLink}
                onClick={cbEditLogin}
              >
                修改
            </a>,
              <a target="_blank"
                className={classes.dropdownLink}

                onClick={cbLogout}
              >
                登出
            </a>
            ]}
          />
        </ListItem>
        {/* {menuItem} */}
      </List>
    );
  }

}

export default withStyles(headerLinksStyle)(HeaderLinks);



// WEBPACK FOOTER //
// ./src/views/HomePage/Sections/Header/HeaderLinks.jsx